import type { ReactNode } from 'react';
import clsx from 'clsx';
import './LevitatingCard.css';

export interface LevitatingCardProps {
  children: ReactNode;
  className?: string;
}

/**
 * Карточка в стиле островной шапки модалки: светлый фон и лёгкая синяя тень (--glow-blue-subtle).
 */
export function LevitatingCard({ children, className }: LevitatingCardProps) {
  return <div className={clsx('levitating-card', className)}>{children}</div>;
}
